import * as React from "react";

import { isPublicSite } from "../configuration";

class InternalContent extends React.Component {
    public render() {
        return (
            <>
                {!isPublicSite() && this.props.children}
            </>
        );
    }
}

export default InternalContent;
